import React from 'react';

// Utils
import { useTranslation } from 'react-i18next';
import withAuth from '../utils/hocs/withAuth';
import withSidebar from '../utils/hocs/withSidebar';
import SCOPE from '../utils/gate/scope';
import withPermission from '../utils/hocs/withPermission';

// Components
import PageWrapper from '../components/layout/PageWrapper/PageWrapper';
import RolesView from '../components/views/common/Roles/Roles';

function Roles() {
  const { t } = useTranslation();

  return (
    <PageWrapper
      title={t('roles.title')}
      hasWhiteWrapper
      breadcrumb={[
        { label: t('admin.title'), href: '/admin' },
      ]}
    >
      <RolesView />
    </PageWrapper>
  );
}

export default withAuth(
  withPermission(
    withSidebar(Roles),
    {
      scopes: [
        SCOPE.get_pla_role,
        SCOPE.get_est_role,
        SCOPE.get_ownEst_role,
      ],
    },
  ),
);
